import React from "react"
import SubpageHeader from "../components/subpageheader"
import SEO from "../components/seo"
import Layout from "../components/layout"

const Agb = () => (
  <>
    <SEO title="AGB" />
    <Layout>
      <div className="content-container">
        <SubpageHeader />
        <h2>AGB</h2>
        <div className="subpage-content meta-info">
          <div className="text">
            <p>Allgemeine Geschäftsbedingungen - Onlineshop Weinguts Müller.</p>

            <h4>§ 1 Angebot und Vertragsabschluss</h4>
            <p>
              Ihre Bestellung bei uns ist Ihr Angebot an uns zum Abschluss eines
              Kaufvertrags der von Ihnen bestellten Weine. Der Eingang der
              Bestellung wird durch uns durch den Versand einer E-Mail an Sie an
              die von Ihnen auf dem Bestellformular angegebene E-Mail Adresse
              bestätigt. Diese E-Mail oder eine sonstige Bestätigung des
              Eingangs der Bestellung stellen ausdrücklich keine Annahme Ihres
              vorangegangenen Angebots über den Abschluss eines Kaufvertrages
              dar.
              <br />
              &nbsp;
              <br />
              Unsere Angebote sind freibleibend. Der Kaufvertrag über von Ihnen
              bestellte Weine kommt erst mit einer Auftragsbestätigung
              unsererseits oder der Versendung des Weines zustande.
              <br />
              &nbsp;
              <br />
              Unsere Allgemeinen Geschäftsbedingungen sind jederzeit auf unserer
              Webseite einsehbar, diese gelten für alle zwischen uns und
              Verbraucher in ihrer zum Zeitpunkt der Bestellung gültigen
              Fassung. Anderslautende Bedingungen werden ohne eine vorherige
              schriftliche Zustimmung nicht anerkannt.
            </p>

            <h4>§ 2 Lieferung</h4>
            <p>
              Hier finden Sie alle Informationen zu unseren Versandkosten und
              Lieferbedingungen:
              <br />
              <a href="/versand">Versandkosten und Lieferbedingungen</a>
            </p>

            <h4>§ 4 Zahlungsbedingungen</h4>
            <p>
              Alle Preise verstehen sich ab unserem Lager als
              Brutto-Einzelpreise. Hinzukommen die Versandkosten. Die Preise
              sind inklusiv der gesetzlichen Mehrwertsteuer, diese wird auf der
              Rechnung separat ausgewiesen. Es gelten grundsätzlich die Preise
              zum Zeitpunkt der Bestellung. Alle vorherigen Preise sind
              ungültig.
              <br />
              <br />
              Der Rechnungsbetrag ist innerhalb 30 Tagen ab Rechnungsdatum ohne
              Abzug zur Zahlung fällig.
              <br />
              <br />
              Überweisungen sind unter Angabe der Buchungs- und Rechnungsnummer
              auf eines der auf der Rechnung angegebenen Konten vorzunehmen.
            </p>

            <h4>§ 5 Jugendschutzgesetz</h4>
            <p>
              Entsprechend dem Jugendschutzgesetz beliefern wir nur Personen ab
              dem vollendeten 18. Lebensjahr. Zur Einhaltung dieser gesetzlichen
              Verpflichtungen, die ausschließlich zum Schutze von Jugendlichen
              bestehen, verpflichten Sie sich bei Bestellung die Angaben zur
              Registrierung, hier insbesondere die Altersangabe, wahrheitsgemäß
              zu machen.
            </p>

            <h4>§ 6 Eigentumsvorbehalt</h4>
            <p>
              Bis zur vollständigen Bezahlung der gelieferten Ware bleibt die
              Ware im Eigentum des Weinguts. <br />
              &nbsp;
              <br />
              Sie sind berechtigt, im Rahmen eines üblichen und ordnungsgemäßen
              Geschäftsverkehrs über die Ware zu verfügen. Nicht zum üblichen
              und ordnungsgemäßen Geschäftsverkehr gehört die Verpfändung oder
              Sicherungsübereignung der Ware, die ausdrücklich untersagt ist. Im
              Fall des Weiterverkaufs treten Sie im Voraus diejenigen
              Forderungen an das Weingut ab, die Ihnen aus der Weiterveräußerung
              zustehen.
              <br />
              &nbsp;
              <br />
              In der Zeit der Ausübung des Eigentumsvorbehalts tragen Sie die
              volle Gefahr für den Stand und Verbleib der Ware sowie sämtliche
              eventuell durch die Ausübung der Eigentumsvorbehaltsrechte
              entstehenden Kosten. Das Weingut ist bei Verstoß gegen die
              vertraglichen Verpflichtungen, insbesondere bei Zahlungsverzug
              oder zu erwartender Zahlungseinstellung berechtigt, die sich noch
              in Ihrem Besitz befindliche Vorbehaltsware auf Ihre Kosten
              abzuholen und / oder die Abtretung etwaiger Herausgabeansprüche
              gegen Dritte zu verlangen.
              <br />
              &nbsp;
              <br />
              <br />
              Widerrufsbelehrung
              <br />
              <br />
            </p>

            <h4>§ 7 Widerrufsrecht</h4>
            <p>
              Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
              diesen Vertrag zu widerrufen.
              <br />
              <br />
              Die Widerrufsfrist beträgt 30 Tage ab dem Tag, an dem Sie oder ein
              von Ihnen benannter Dritter, der nicht der Beförderer ist, die
              Waren in Besitz genommen haben bzw. hat.
              <br />
              <br />
              Um Ihr Widerrufsrecht auszuüben, müssen Sie uns mittels einer
              eindeutigen Erklärung (z. B. ein mit der Post versandter Brief,
              Telefax oder E-Mail)über Ihren Entschluss, diesen Vertrag zu
              widerrufen, informieren. Sie können dafür das der Ware beigefügte
              Muster-Widerrufsformular verwenden, das jedoch nicht
              vorgeschrieben ist. Zur Wahrung der Widerrufsfrist reicht es aus,
              dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor
              Ablauf der Widerrufsfrist absenden.
              <br />
              <br />
              &nbsp;
              <br />
              <br />
              § 8 Folgen des Widerrufs
              <br />
              <br />
              Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle
              Zahlungen, die wir von Ihnen erhalten haben, einschließlich der
              Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich
              daraus ergeben, dass Sie eine andere Art der Lieferung als die von
              uns angebotene, günstigste Standardlieferung gewählt haben),
              unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag
              zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses
              Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden
              wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen
              Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde
              ausdrücklich etwas anderes vereinbart; in keinem Fall werden Ihnen
              wegen dieser Rückzahlung Entgelte berechnet. Wir können die
              Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten
              haben oder bis Sie den Nachweis erbracht haben, dass Sie die Waren
              zurückgesandt haben, je nachdem, welches der frühere Zeitpunkt
              ist.
              <br />
              <br />
              Sie haben die Waren unverzüglich und in jedem Fall spätestens
              binnen vierzehn Tagen ab dem Tag, an dem Sie uns über den Widerruf
              dieses Vertrags unterrichten, an uns zurückzusenden oder zu
              übergeben. Die Frist ist gewahrt, wenn Sie die Waren vor Ablauf
              der Frist von vierzehn Tagen absenden. Die Kosten für die
              Rücksendung Ware übernehmen wir, wenn Sie dies mit dem von uns zur
              Verfügung gestellten vorfrankierten Rücksendeaufkleber versenden.
              <br />
              <br />
              Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen,
              wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit,
              Eigenschaften und Funktionsweise der Waren nicht notwendigen
              Umgang mit ihnen zurückzuführen ist.
            </p>

            <h4>§ 9 Gewährleistung</h4>
            <p>
              Das Weingut gewährleistet dass die gelieferten Produkte zum
              Zeitpunkt der Übergabe frei von Sachmängeln sind. Für alle während
              der gesetzlichen Gewährleistungsfrist auftretenden Mängel der Ware
              gelten nach Wahl des Kunden die gesetzlichen Ansprüche auf
              Nacherfüllung, Mangelbeseitigung / Neulieferung sowie - bei
              Vorliegen der gesetzlichen Voraussetzungen – die weitergehenden
              Ansprüche auf Minderung oder Rücktritt sowie daneben auf
              Schadensersatz, einschließlich des Ersatzes des Schadens statt der
              Erfüllung sowie des Ersatzes vergeblicher Aufwendungen. Das
              Weingut ist berechtigt, die Art der gewählten Nacherfüllung zu
              verweigern, wenn diese nur mit unverhältnismäßigen Kosten möglich
              ist und die andere Art der Nacherfüllung ohne erheblichen Nachteil
              für den Kunden bleibt.
              <br />
              &nbsp;
              <br />
              Da es sich bei Wein um ein Naturprodukt handelt können durch die
              Lagerung Weinsteinkristalle etc. entstehen, die die Qualität des
              gelieferten Produktes nicht beeinträchtigen. Auch Abweichungen im
              Hinblick auf Farbe etc. sind eventuell natürliche Vorgänge und
              stellen keine Mängel dar.
            </p>

            <h4>§ 10 Haftungsbeschränkung</h4>
            <p>
              Das Weingut haftet nur in Fällen, in denen es oder ein von ihm
              bestellter Erfüllungsgehilfe vorsätzlich oder grob fahrlässig
              handelt. Vorstehendes gilt nicht, soweit für Schäden aus der
              Verletzung des Lebens, des Körpers oder der Gesundheit gehaftet
              wird sowie im Falle der Verletzung wesentlicher Vertragspflichten.
              Außer bei Vorsatz, grober Fahrlässigkeit und Schäden aus der
              Verletzung des Lebens, des Körpers oder der Gesundheit ist die
              Haftung der Höhe nach auf die bei Vertragsabschluss typischerweise
              vorhersehbaren Schäden begrenzt.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  </>
)

export default Agb
